import { render, staticRenderFns } from "./CookieDialog.vue?vue&type=template&id=9618f312&scoped=true"
import script from "./CookieDialog.vue?vue&type=script&lang=js"
export * from "./CookieDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9618f312",
  null
  
)

export default component.exports